import type { IconSize } from '../icons';
import { ApplicationFileIcon } from './application-file-icon';
import { ContentFileIcon } from './content-file-icon';
import { TextFileIcon } from './text-file-icon';

type P = {
  contentType?: string;
  imageFileFallback?: string;
  imagePreview?: boolean;
  size?: IconSize;
  url?: string;
};

const FileIcon = ({ contentType, imageFileFallback, imagePreview, size, url }: P) => {
  const iconSize = size ?? (imagePreview === false ? 'middle' : 'large');
  const [type = '', subtype = ''] = (contentType ?? '').split('/');

  switch (type) {
    case 'application':
      return <ApplicationFileIcon size={iconSize} subtype={subtype} />;
    case 'text':
      return <TextFileIcon size={iconSize} subtype={subtype} />;
    default:
      return (
        <ContentFileIcon
          imageFileFallback={imageFileFallback}
          imagePreview={imagePreview}
          size={iconSize}
          type={type}
          url={url}
        />
      );
  }
};

export default FileIcon;
